module.exports = __webpack_public_path__ + "img/Equity Finance.ed4319ce.png";